var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomHookOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,9.9v1.3v0.4l1.1-0.6c0.3-0.2,0.6-0.2,0.9-0.1v-1c2.1-0.6,3.4-2.8,2.9-4.9c-0.5-2.2-2.7-3.4-4.9-2.9 C10.7,2.7,9.4,4.8,9.9,7C10.3,8.4,11.4,9.5,12.8,9.9z M13.8,4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2 C11.8,4.9,12.7,4,13.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,19.1c-0.5,0.5-1.3,0.9-2.1,0.9c-1.7,0-3-1.3-3-3h3l-5-5v5c0,2.3,1.6,4.3,3.8,4.8 c1.2,0.3,2.5,0.1,3.5-0.6c0-0.1,0.1-0.2,0.1-0.4C12.7,20.1,12.5,19.4,11.9,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,15.4c-0.9,0-1.2-0.6-0.8-1.4c0.3-0.4,0.1-1-0.3-1.3l-0.8-0.5c-0.4-0.2-0.9-0.1-1.1,0.3l-0.1,0.1 c-0.4,0.8-1.2,0.8-1.6,0l-0.1-0.1c-0.2-0.4-0.7-0.5-1.1-0.3l-0.8,0.5c-0.4,0.3-0.6,0.8-0.3,1.3c0.4,0.8,0.1,1.4-0.8,1.4 c-0.5,0-0.9,0.4-0.9,0.9v0.9c0,0.5,0.4,0.9,0.9,0.9c0.9,0,1.2,0.6,0.8,1.4c-0.3,0.4-0.1,1,0.3,1.3l0.8,0.5c0.4,0.2,0.9,0.1,1.1-0.3 l0.1-0.1c0.4-0.8,1.2-0.8,1.6,0l0.1,0.1c0.2,0.4,0.7,0.5,1.1,0.3l0.8-0.5c0.4-0.3,0.6-0.8,0.3-1.3c-0.4-0.8-0.1-1.4,0.8-1.4 c0.5,0,0.9-0.4,0.9-0.9v-0.9C21.4,15.8,21,15.4,20.5,15.4z M16.5,18.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 c0.9,0,1.6,0.7,1.6,1.6S17.4,18.3,16.5,18.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomHookOff);
export default __webpack_public_path__ + "static/media/custom-hook-off.176200ce5be379240a4dcaced77899b1.svg";
export { ForwardRef as ReactComponent };